import { compose, find, invoker, toString } from "ramda";

const getId = invoker(0, 'get_id');

const getIdString = compose(
    toString,
    getId,
);

const getIsRoot = invoker(0, 'get_isRoot');

const getParent = invoker(0, 'get_parent');

const getName = invoker(0, 'get_name');

const termToObject = (term) => {
    const isRoot = getIsRoot(term);
    const parent = isRoot ? null : getParent(term);

    return {
        id: getIdString(term),
        name: getName(term),
        parentPath: isRoot ? '' : parent.get_pathOfTerm(),
        parentId: parent ? getIdString(parent) : null,
        isRoot,
    };
};

const termSetToObject = (termSet, terms, termNameFilter) => {
    const termsData = terms.get_data();
    const filteredTerms = termNameFilter
        ? termsData.filter(t => termNameFilter(getName(t)))
        : termsData;

    return {
        id: getIdString(termSet),
        name: getName(termSet),
        terms: filteredTerms.map(termToObject),
    };
};

const termSetsToObjects = (termSets, termNameFilter) => 
    termSets.map(
        ({ termSet, terms }) => termSetToObject(termSet, terms, termNameFilter)
    );

export {
    termSetsToObjects,
};